<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-flex ts-space-x-4">
        <div class="ts-border ts-border-gray-400 ts-rounded-md ts-w-1/2 ts-p-3">
          <div class="ts-flex ts-space-x-3 ts-items-center ts-mb-3">
            <button
              class="
                ts-outline-none
                ts-font-bold
                ts-bg-blue-200
                ts-p-2
                ts-rounded-sm
                ts-capitalize
              "
              @click="() => (show_stock_in_modal = true)"
            >
              {{ $t('productLabel.fromPurchaseInvoice') }}
            </button>
            <h5 class="ts-mb-0" v-if="purchaseInvoice.stock_in_number">
              {{ purchaseInvoice.stock_in_number }}
              <span
                @click.prevent="() => (purchaseInvoice = {})"
                class="
                  ts-bg-gray-400 ts-px-2 ts-rounded-full
                  hover:ts-bg-red-600 hover:ts-text-white
                  ts-cursor-pointer
                  ts-transform
                  ts-transition-all
                  ts-duration-150
                "
                >x</span
              >
            </h5>
          </div>
          <div>
            <SearchBox v-model="modelSearch.product_id"/>
          </div>
          <div class="ts-flex ts-items-center ts-space-x-3 ts-mt-3">
            <div class="ts-flex ts-space-x-3 ts-items-center ts-border ts-border-gray-300 ts-rounded ts-py-1 ts-px-2">
              <b>{{ $t('productLabel.grade') }}</b>
              <input v-model="modelSearch.grade" @change="fetchResource()" type="checkbox" value="A" name="grade" class="ts-p-0" > <span class="ts-pt-1 ts-ml-1 ts-text-blue-700 ts-font-semibold">A</span>
              <input v-model="modelSearch.grade" @change="fetchResource()" type="checkbox" value="B" name="grade" class="ts-p-0" > <span class="ts-pt-1 ts-ml-1 ts-text-blue-700 ts-font-semibold">B</span>
              <input v-model="modelSearch.grade" @change="fetchResource()" type="checkbox" value="C" name="grade" class="ts-p-0" > <span class="ts-pt-1 ts-ml-1 ts-text-blue-700 ts-font-semibold">C</span>
              <input v-model="modelSearch.grade" @change="fetchResource()" type="checkbox" value="D" name="grade" class="ts-p-0" > <span class="ts-pt-1 ts-ml-1 ts-text-blue-700 ts-font-semibold">D</span>
            </div>
            <input type="checkbox"
              v-model.number="modelSearch.is_printed"
              @change="fetchResource()"
              class="ts-ml-3"
            ><span class="ts-ml-1">{{ $t('productLabel.printed') }}</span>
          </div>
            <p class="ts-font-semibold ts-mt-3" >{{ $t('productLabel.selected') + ' ' + leftSelected.length + '/' + (totalRecord - productRightList.length)  }}</p>
          <div class="ts-flex-none max-height min-height ts-mt-3">
            <table class="ts-w-full">
              <thead>
                <tr>
                  <th
                    class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3 ts-w-3"
                  >
                    <input
                      type="checkbox"
                      class="ts-mt-1"
                      v-model="leftListIsAllCheck"
                      @change="onLeftListAllCheckChange"
                    />
                  </th>
                  <th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3">
                    {{ $t('productLabel.serialNo') }}
                  </th>
                  <th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3">
                    {{ $t('productLabel.productGroup') }}
                  </th>
                  <th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3">
                    {{ $t('productLabel.nameEn') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(pro, index) in productList" :key="index">
                  <td class="ts-py-1 ts-px-3 ts-w-3">
                    <input
                      type="checkbox"
                      v-model="leftSelected"
                      :value="pro"
                      @change="onLeftItemChange"
                    />
                  </td>
                  <td class="ts-py-1 ts-px-3">{{ pro.serial_no }}</td>
                  <td class="ts-py-1 ts-px-3">{{ pro.pro_group_name_en }}</td>
                  <td class="ts-py-1 ts-px-3">{{ pro.product_name_en }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <br>
          <a-pagination 
            v-if="totalRecord > 0"
            size="small" 
            :pageSize="perPage" 
            :total="totalRecord"
            :showSizeChanger="true"
            :pageSizeOptions="['300', '500', '1000']"
            @showSizeChange="onPerPageChange"
            @change="onPaginChange"
            class="ts-float-right" 
          />
        </div>
        <div class="ts-flex ts-items-center">
          <div class="ts-h-24 ts-space-y-3 ts-flex-none">
            <button
              @click.prevent="moveToRight"
              class="
                ts-bg-gray-300 ts-px-3 ts-py-1 ts-rounded
                focus:ts-outline-none
              "
            >
              <i class="fas fa-chevron-right"></i>
            </button>
            <br />
            <button
              @click.prevent="moveLeft"
              class="
                ts-bg-gray-300 ts-px-3 ts-py-1 ts-rounded
                focus:ts-outline-none
              "
            >
              <i class="fas fa-chevron-left"></i>
            </button>
          </div>
        </div>
        <div class="ts-border ts-border-gray-400 ts-rounded-md ts-w-1/2 ts-p-3">
          <div class="ts-flex-none max-height min-height">
            <table class="ts-w-full">
              <thead>
                <tr>
                  <th
                    class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3 ts-w-3"
                  >
                    <input
                      type="checkbox"
                      class="ts-mt-1"
                      v-model="rightListIsAllCheck"
                      @change="onRightListAllCheckChange"
                    />
                  </th>
                  <th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3">
                    {{ $t('productLabel.serialNo') }}
                  </th>
                  <th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3">
                    {{ $t('productLabel.productGroup') }}
                  </th>
                  <th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3">
                    {{ $t('productLabel.nameEn') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(pro, index) in productRightList" :key="index">
                  <td class="ts-py-1 ts-px-3 ts-w-3">
                    <input
                      type="checkbox"
                      v-model="righSelected"
                      :value="pro"
                      @change="onRightItemChange"
                    />
                  </td>
                  <td class="ts-py-1 ts-px-3">{{ pro.serial_no }}</td>
                  <td class="ts-py-1 ts-px-3">{{ pro.pro_group_name_en }}</td>
                  <td class="ts-py-1 ts-px-3">{{ pro.product_name_en }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="ts-flex ts-justify-end ts-mt-3 ts-space-x-3 ts-w-full">
        <ts-button
          :waiting="waiting"
          @click.prevent="onPreview"
          color="primary"
          >{{ $t('preview') }}</ts-button
        >
      </div>
    </ts-loading-banner>
    <a-modal :title="$t('pdf')" width="700px" v-model="show_pdf" :footer="null">
      <ts-preview-pdf v-model="waiting" :src="src" />
    </a-modal>
    <a-modal
      :title="$t('productLabel.purchaseInvoice')"
      width="700px"
      v-model="show_stock_in_modal"
      :zIndex="1020"
      :footer="null"
    >
      <PurchaseInvoice @choosen="onPurchaseInvoiceChose" />
    </a-modal>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
import SearchBox from './search-box'
import PurchaseInvoice from './purchase-invoice.vue'
export default {
  name: 'productLabel',
  components: {
    SearchBox,
    PurchaseInvoice,
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      show_pdf: false,
      show_stock_in_modal: false,
      waiting: false,
      src: '',
      purchaseInvoice: {},
      productSearch: {
        text: '',
      },
      leftListIsAllCheck: false,
      rightListIsAllCheck: false,
      leftSelected: [],
      righSelected: [],
      productResources: [],
      productRightList: [],
      totalRecord: 0,
      page: 1,
      perPage: 300,
      model: {
        product_list_serial_no: [],
      },
      modelSearch: {
        product_id: [],
        grade: [],
        is_printed: false
      }
    }
  },
  computed: {
    productList() {
      return this.productResources.filter(
        (p) => !_.includes(this.model.product_list_serial_no, p.serial_no) &&
        p.is_printed == this.modelSearch.is_printed
      )
    }
  },
  // created() {
  //   this.fetchResource()
  // },
  methods: {
    ...mapActions('product/label', ['getProductSerial', 'store']),
    fetchResource() {
      this.loading = true
      this.leftSelected = []
      this.getProductSerial(Object.assign({}, this.modelSearch, {
          ref_stock_in_id: this.purchaseInvoice.stock_in_id,
          page: this.page,
          per_page: this.perPage
        })
      )
        .then((response) => {
          this.productResources = response.data
          this.totalRecord = response.meta.total
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    // check all item in the left panel
    onLeftListAllCheckChange(e) {
      if (e.target.checked) {
        this.leftSelected = this.productList.map((el) => el)
      } else {
        this.leftSelected = []
      }
    },
    // check all item in the right panel
    onRightListAllCheckChange(e) {
      if (e.target.checked) {
        this.righSelected = this.productRightList.map((el) => el)
      } else {
        this.righSelected = []
      }
    },
    // check weather all lett item is check or not
    onLeftItemChange() {
      this.leftListIsAllCheck =
        this.leftSelected.length == this.productList.length
    },
    // check weather all right item is check or not
    onRightItemChange() {
      this.leftListIsAllCheck =
        this.leftSelected.length == this.productRightList.length
    },
    // action move item to the right panel
    moveToRight() {
      this.model.product_list_serial_no.push(...this.leftSelected.map(el => el.serial_no))
      this.productRightList.push(...this.leftSelected)
      this.leftSelected = []
      this.leftListIsAllCheck = false
    },
    // action move item to the left back panel
    moveLeft() {
      this.model.product_list_serial_no =
        this.model.product_list_serial_no.filter(
          (p) => !_.includes(this.righSelected.map(el => el.serial_no), p)
        )
      this.productRightList = this.productRightList.filter(
        (p) => !_.includes(this.righSelected.map(el => el.serial_no), p.serial_no)
      )
      this.righSelected = []
      this.rightListIsAllCheck = false
    },
    onPreview() {
      this.src = ''
      this.waiting = true
      this.show_pdf = true
      this.errors = new Errors()
      this.store(this.model)
        .then((response) => {
          this.src = response.url
          this.updateStatus()
          this.clearInput()
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          this.show_pdf = false
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onPurchaseInvoiceChose(record) {
      this.purchaseInvoice = record
      this.show_stock_in_modal = false
      this.fetchResource()
    },
    clearInput() {
      this.model.product_list_serial_no = []
      this.productRightList = []
    },
    updateStatus(){
      this.model.product_list_serial_no.forEach(serial_no => {
          this.productResources[this.productResources.findIndex(s => s.serial_no == serial_no)].is_printed = true
      });
    },
    onPaginChange(page, pageSize){
      this.page = page
      this.fetchResource()
    },
    onPerPageChange(current, size){
      this.perPage = size
      this.fetchResource()
    },
  },
  watch: {
    'modelSearch.product_id': debounce(function (search) {
      this.fetchResource()
    }, 700),
  },
}
</script>

<style scoped lang="css">
.max-height {
  max-height: 500px;
  overflow-y: scroll;
}
.min-height {
  min-height: 400px;
}
</style>